import Model from './Model';

export default class OtherIntegration extends Model {
  resource() {
    return 'other_integration';
  }
}
